module.exports = __webpack_public_path__ + "8a5356e9/img/dollar-icon.35c9d638.svg";